import { initializePhotoPreview } from './initialize-photo-preview';

export function initializeDeviceCard() {
    const tabButtons = document.querySelectorAll(
        '.card-details-tabs-nav .tab-btn',
    );
    const tabPanes = document.querySelectorAll(
        '.card-details-tabs-content .tab-pane',
    );
    const tabsContentContainer = document.querySelector(
        '.card-details-tabs-content',
    );

    let activeTabId = sessionStorage.getItem('activeDeviceTab');

    if (!activeTabId) {
        activeTabId =
            tabButtons.length > 0 ? tabButtons[0].dataset.tab : 'information';
    }

    const savedButton = document.querySelector(
        `.tab-btn[data-tab="${activeTabId}"]`,
    );
    const savedPane = document.getElementById(`tab-${activeTabId}`);

    if (savedButton && savedPane) {
        tabButtons.forEach((btn) => btn.classList.remove('active'));
        tabPanes.forEach((pane) => pane.classList.remove('active'));

        savedButton.classList.add('active');
        savedPane.classList.add('active');
    }

    if (tabsContentContainer) {
        setTimeout(() => {
            tabsContentContainer.classList.add('initialized');
        }, 10);
    }

    tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const tabId = button.dataset.tab;

            tabButtons.forEach((btn) => btn.classList.remove('active'));
            tabPanes.forEach((pane) => pane.classList.remove('active'));

            button.classList.add('active');
            const activePane = document.getElementById(`tab-${tabId}`);
            if (activePane) {
                activePane.classList.add('active');
                sessionStorage.setItem('activeDeviceTab', tabId);
            }
        });
    });

    initializePhotoPreview(document);
}
